module.exports = __webpack_public_path__ + "img/commitFour.57794914.png";